{
  "title": "Billing",
  "description": "Your school's subscription, seats and invoices.",
  "loadFailed": "The billing information could not be loaded.",
  "disabled": {
    "title": "Billing is not configured",
    "description": "This installation runs without a payment provider, so there is nothing to set up here and nothing to pay. Your school keeps full access."
  },
  "status": {
    "label": "Status",
    "trialing": "Trial",
    "active": "Active",
    "past_due": "Payment overdue",
    "canceled": "Canceled",
    "locked": "Access paused",
    "none": "No subscription"
  },
  "summary": {
    "title": "Subscription",
    "trialDaysLeft_one": "{{count}} day left",
    "trialDaysLeft_other": "{{count}} days left",
    "trialEndsToday": "ends today",
    "trialEndsOn": "Your trial ends on {{date}}.",
    "trialSoon": "Choose a plan before then to keep access to your school's data.",
    "renewsOn": "Renews on {{date}}",
    "endsOn": "Access runs until {{date}}",
    "planMonthly": "Monthly plan",
    "planAnnual": "Annual plan",
    "cancelAtPeriodEnd": "This subscription is set to end on {{date}}. You can resume it from the billing portal.",
    "pastDue": "The last payment did not go through. Your school keeps working while the payment is retried — updating the payment method in the billing portal resolves it.",
    "locked": "Access to this school is paused until a payment is completed. Nothing has been deleted.",
    "retention": "Your data is kept until {{date}}.",
    "noSubscription": "This school has no subscription yet.",
    "contactAdmin": "Only an administrator of this school can change the subscription. Ask them if something needs updating."
  },
  "seats": {
    "title": "Seats",
    "count_one": "{{count}} teaching seat",
    "count_other": "{{count}} teaching seats",
    "explanation": "Each administrator and teacher takes a seat. Pupils and parents are free and unlimited.",
    "manageMembers": "Manage members"
  },
  "price": {
    "title": "What it costs",
    "perSeatMonth": "{{amount}} per seat / month",
    "perSeatYear": "{{amount}} per seat / year",
    "monthly": "Monthly",
    "annual": "Annual",
    "totalPerMonth": "{{amount}} / month",
    "totalPerYear": "{{amount}} / year",
    "listPrice": "Standard price {{amount}} per seat / month.",
    "discountApplied": "{{percent}}% volume discount applied — it starts at {{minSeats}} seats.",
    "discountAt": "Schools with {{minSeats}} seats or more pay less for every seat.",
    "annualSaving": "Saves {{amount}} a year compared with paying monthly.",
    "note": "Prices shown for your current seat count. Stripe charges the amount on your invoice."
  },
  "actions": {
    "title": "Choose a plan",
    "interval": "Billing period",
    "subscribe": "Continue to payment",
    "subscribing": "Opening Stripe…",
    "manage": "Manage billing",
    "managing": "Opening the portal…",
    "manageNote": "Payment method, plan changes and cancellation are handled on Stripe's billing portal.",
    "stripeNote": "You will be taken to Stripe to pay. Osvitly never sees your card details.",
    "failed": "The payment page could not be opened. Please try again."
  },
  "checkout": {
    "success": "Payment received. Stripe confirms the subscription within a moment — the new status will appear here shortly.",
    "canceled": "Checkout was canceled. Nothing has been charged."
  },
  "invoices": {
    "title": "Invoices",
    "number": "Invoice",
    "date": "Date",
    "amount": "Amount",
    "status": "Status",
    "view": "View",
    "pdf": "PDF",
    "empty": "No invoices yet.",
    "loadFailed": "The invoices could not be loaded.",
    "statuses": {
      "draft": "Draft",
      "open": "Open",
      "paid": "Paid",
      "void": "Void",
      "uncollectible": "Uncollectible"
    }
  },
  "paused": {
    "title": "School access paused",
    "heading": "{{school}} is on hold",
    "description": "This school's subscription is inactive, so the app is read-only for everyone until it is restored. No lessons, grades or files have been deleted.",
    "retention": "Your school's data is kept until {{date}}.",
    "askAdmin": "An administrator of this school needs to complete the payment. Once they do, everything comes straight back.",
    "adminAction": "Go to billing",
    "switchSchool": "If you belong to another school, switch to it from the school selector at the top of the page."
  },
  "dashboard": {
    "trialTitle": "Trial",
    "pastDueTitle": "Payment overdue",
    "trialBody_one": "Your school's trial ends in {{count}} day.",
    "trialBody_other": "Your school's trial ends in {{count}} days.",
    "trialBodyToday": "Your school's trial ends today.",
    "pastDueBody": "The last payment did not go through. Updating the payment method keeps the school running.",
    "open": "Open billing"
  }
}
